"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var LoginForm_1 = __importDefault(require("../../Login/LoginForm"));

var MyAccountMenu_1 = __importDefault(require("../MyAccountMenu"));

var gatsby_1 = require("gatsby");

var frontend_application_1 = require("@ryerson/frontend.application");

var Utils_1 = require("../Helpers/Utils");

var StructuredHamburgerMenu_1 = __importDefault(require("../../HamburgerMenu/StructuredHamburgerMenu"));

var frontend_common_1 = require("@ryerson/frontend.common");

var util_1 = require("../../common/util");

var MobileSearch_1 = __importDefault(require("../Helpers/MobileSearch"));

var WindowOverlay_1 = __importDefault(require("../../common/WindowOverlay"));

var frontend_common_2 = require("@ryerson/frontend.common");

var BarcodeScanner_1 = __importDefault(require("../BarcodeScanner/BarcodeScanner"));

var frontend_button_1 = require("@ryerson/frontend.button");

var StyledComponents_1 = require("../../Renderers/StyledComponents");

var BarcodeScanResults_1 = __importDefault(require("../BarcodeScanner/BarcodeScanResults"));

var LogoRenderer_1 = require("../../Renderers/LogoRenderer");

var ShoppingCartRenderer_1 = require("../../Renderers/ShoppingCartRenderer");

var PhoneLinkRenderer_1 = require("../../Renderers/PhoneLinkRenderer");

var HeaderConfig_1 = require("../../common/HeaderConfig/HeaderConfig");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var common_permissions_1 = require("@ryerson/common.permissions");

var frontend_notification_1 = require("@ryerson/frontend.notification");

var SwapAccountMobile_1 = __importDefault(require("../SwapAccount/SwapAccountMobile"));

var alertData_1 = require("../Helpers/alertData");

var FullHeaderMobile = function FullHeaderMobile(_ref) {
  var headerData = _ref.headerData,
      isSticky = _ref.isSticky,
      contentElementStyle = _ref.contentElementStyle,
      storeDirectory = _ref.storeDirectory,
      locationData = _ref.locationData,
      companyName = _ref.companyName;

  var _a;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      setLocalization = _ref2.setLocalization,
      _ref2$user = _ref2.user,
      isLoggedIn = _ref2$user.isLoggedIn,
      _ref2$user$token = _ref2$user.token,
      token = _ref2$user$token === void 0 ? "" : _ref2$user$token,
      _ref2$user$account = _ref2$user.account,
      account = _ref2$user$account === void 0 ? "" : _ref2$user$account,
      _ref2$localization = _ref2.localization,
      language = _ref2$localization.language,
      country = _ref2$localization.country;

  var _ref3 = (0, frontend_e_commerce_1.useEcommerce)(),
      shoppingCart = _ref3.shoppingCart,
      purchaseOrderNumber = _ref3.purchaseOrderNumber;

  var UserPermissionUtil = new common_permissions_1.UserPermission(token);
  var canRenderCartDisplay = UserPermissionUtil.has(common_permissions_1.Permission.Cart_View_Edit);

  var _ref4 = (0, frontend_theme_1.useTheme)(),
      theme = _ref4.theme,
      themeName = _ref4.themeName;

  var _ref5 = (0, react_1.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      menuActive = _ref6[0],
      setMenuActive = _ref6[1];

  var _theme$colors = theme.colors,
      _theme$colors$seconda = _theme$colors.secondary,
      darkBlue = _theme$colors$seconda.darkBlue,
      red = _theme$colors$seconda.red,
      _theme$colors$primary = _theme$colors.primary,
      darkerGray = _theme$colors$primary.darkerGray,
      success = _theme$colors$primary.success;
  var _theme$colors$primary2 = theme.colors.primary,
      accentBrand = _theme$colors$primary2.accentBrand,
      lightGray = _theme$colors$primary2.lightGray,
      white = _theme$colors$primary2.white;
  var shoppingCartColors = (0, ShoppingCartRenderer_1.getShoppingCartColors)(theme, themeName);

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      openLogin = _react_1$default$useS2[0],
      setOpenLogin = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      openMyAccountMenu = _react_1$default$useS4[0],
      setOpenMyAccountMenu = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(false),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      openBarcodeScanResults = _react_1$default$useS6[0],
      setOpenBarcodeScanResults = _react_1$default$useS6[1];

  var _ref7 = (0, react_1.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      swapAccount = _ref8[0],
      setSwapAccount = _ref8[1];

  var _ref9 = (0, react_1.useState)(false),
      _ref10 = _slicedToArray(_ref9, 2),
      searchVisible = _ref10[0],
      setSearchVisible = _ref10[1];

  var _ref11 = (0, react_1.useState)(false),
      _ref12 = _slicedToArray(_ref11, 2),
      scannerVisible = _ref12[0],
      setScannerVisible = _ref12[1];

  var _react_1$default$useS7 = react_1.default.useState(""),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      scanResult = _react_1$default$useS8[0],
      setScanResult = _react_1$default$useS8[1];

  var _react_1$default$useS9 = react_1.default.useState(""),
      _react_1$default$useS10 = _slicedToArray(_react_1$default$useS9, 2),
      scanError = _react_1$default$useS10[0],
      setScanError = _react_1$default$useS10[1];

  var headerSettings = HeaderConfig_1.headerConfigData[companyName];

  var handleMenuClose = function handleMenuClose(params) {
    var _ref13 = params || {},
        url = _ref13.url,
        country = _ref13.country,
        language = _ref13.language;

    setMenuActive(false);
    url && (0, gatsby_1.navigate)((0, util_1.getUrl)(url));
    country && setLocalization(function (prev) {
      return Object.assign(Object.assign({}, prev), {
        country: country
      });
    });
    language && setLocalization(function (prev) {
      return Object.assign(Object.assign({}, prev), {
        language: language
      });
    });
  };

  var toggleMenuItems = function toggleMenuItems(openItem) {
    if (openItem === "loginMenu") {
      setMenuActive(false);
      sessionStorage.setItem(frontend_common_1.SessionItems.hamburgerActive, "false");
    } else {
      setOpenLogin(false);
      setOpenMyAccountMenu(false);
    }
  }; // Barcode Scanner Callback: Detect Camera Permission is not on


  var onCameraError = function onCameraError(error) {
    if (error === "NotAllowedError") {
      setScanError(frontend_common_1.withTranslation.cameraPermissionError[language]);
    } else {
      setScanError(error);
    }
  };

  react_1.default.useEffect(function () {
    if (scanResult) {
      setScannerVisible(false);
      setOpenBarcodeScanResults(true);
    }
  }, [scanResult]);
  react_1.default.useEffect(function () {
    scanResult && setScanResult("");
  }, [openBarcodeScanResults, scannerVisible]);
  react_1.default.useEffect(function () {
    var _a, _b, _c; // if switch from desktop to mobile header while in sticky mode


    var contentEl = (_c = (_b = (_a = document === null || document === void 0 ? void 0 : document.querySelector(".header-mobile")) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.nextElementSibling) === null || _c === void 0 ? void 0 : _c.nextElementSibling; // remove extra padding

    if (isSticky.current && contentEl) {
      contentEl && (0, Utils_1.setStyleOfElement)(contentEl, contentElementStyle.current);
    }
  }, []);
  var totalItemsInCart = ((_a = shoppingCart === null || shoppingCart === void 0 ? void 0 : shoppingCart.items) === null || _a === void 0 ? void 0 : _a.length) || 0;
  return (0, jsx_runtime_1.jsx)(StyledComponents_1.HeaderWrapperMobile, {
    className: "header-mobile",
    theme: theme,
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Container, {
      vPadding: "0",
      hPadding: "0",
      children: [(0, jsx_runtime_1.jsx)(StyledComponents_1.UtilityNavigationMobile, {
        theme: theme,
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          style: StyledComponents_1.navigation,
          alignItems: "center",
          children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            grow: 1,
            children: (0, PhoneLinkRenderer_1.renderPhoneLink)(headerSettings, country)
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                style: StyledComponents_1.loginTextMobile,
                justifyContent: "flex-end",
                alignItems: "center",
                onClick: function onClick() {
                  isLoggedIn ? setOpenMyAccountMenu(function (prevState) {
                    searchVisible && setSearchVisible(false);
                    scannerVisible && setScannerVisible(false);
                    return !prevState;
                  }) : setOpenLogin(function (prevState) {
                    searchVisible && setSearchVisible(false);
                    scannerVisible && setScannerVisible(false);
                    return !prevState;
                  });
                  toggleMenuItems("loginMenu");
                },
                children: isLoggedIn ? (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "person",
                  size: "sm",
                  color: accentBrand
                }) : (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  color: lightGray,
                  size: "md",
                  children: "Log In"
                })
              }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                style: (0, StyledComponents_1.utilityNavText)(theme),
                justifyContent: "center",
                alignItems: "center",
                children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "barcode",
                  size: "sm",
                  color: white,
                  onClick: function onClick() {
                    !isLoggedIn && (0, gatsby_1.navigate)("/login", {
                      state: {
                        message: "You must be logged in to scan a product."
                      }
                    });
                    isLoggedIn && setScannerVisible(function (prevState) {
                      searchVisible && setSearchVisible(false);
                      openLogin && setOpenLogin(false);
                      openMyAccountMenu && setOpenMyAccountMenu(false);
                      menuActive && setMenuActive(false);
                      setOpenBarcodeScanResults(false); // note: delay to mitigate hamburger transition interfering with scanner render

                      menuActive ? setTimeout(function () {
                        return setScannerVisible(!prevState);
                      }, 500) : prevState = !prevState;
                      return prevState;
                    });
                  }
                })
              }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                style: (0, StyledComponents_1.utilityNavText)(theme),
                justifyContent: "center",
                alignItems: "center",
                children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "search",
                  size: "sm",
                  onClick: function onClick() {
                    return setSearchVisible(function (prevState) {
                      scannerVisible && setScannerVisible(false);
                      openLogin && setOpenLogin(false);
                      openMyAccountMenu && setOpenMyAccountMenu(false);
                      menuActive && setMenuActive(false);
                      menuActive ? setTimeout(function () {
                        return setSearchVisible(!prevState);
                      }, 500) : prevState = !prevState;
                      return prevState;
                    });
                  },
                  color: white
                })
              }), canRenderCartDisplay && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                style: (0, StyledComponents_1.shoppingCartSection)(shoppingCartColors.background),
                justifyContent: "center",
                alignItems: "center",
                onClick: function onClick() {
                  (0, gatsby_1.navigate)(storeDirectory + "/cart");
                },
                children: totalItemsInCart > 0 ? (0, jsx_runtime_1.jsx)(frontend_notification_1.Badge, {
                  type: "primary",
                  size: "sm",
                  badgeContent: totalItemsInCart.toString(),
                  badgeType: "notification",
                  children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                    icon: "shopping-cart",
                    size: "sm",
                    color: shoppingCartColors.content,
                    onClick: function onClick() {
                      (0, gatsby_1.navigate)(storeDirectory + "/cart");
                    }
                  })
                }) : (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "shopping-cart",
                  size: "sm",
                  color: shoppingCartColors.content,
                  onClick: function onClick() {
                    (0, gatsby_1.navigate)(storeDirectory + "/cart");
                  }
                })
              })]
            })
          })]
        })
      }), !searchVisible && (0, jsx_runtime_1.jsx)(StyledComponents_1.GlobalNavigationMobile, {
        theme: theme,
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          style: StyledComponents_1.navigation,
          alignItems: "center",
          children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, LogoRenderer_1.LogoRenderer)({
              companyName: companyName,
              isMobile: true
            })
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            grow: 1
          }), account === "99" && (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsx)("div", {
              style: {
                backgroundColor: theme.colors.secondary.lightRed
              },
              children: (0, jsx_runtime_1.jsx)(frontend_notification_1.Alert, {
                severity: "error",
                outline: true,
                size: "sm",
                children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  color: theme.colors.primary.darkerGray,
                  weight: "bold",
                  size: "xs",
                  children: alertData_1.selectCustomer[language]
                })
              })
            })
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            grow: 1
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                justifyContent: "center",
                alignItems: "center",
                style: (0, StyledComponents_1.navMenuSection)(theme),
                children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "list-lines",
                  size: "sm",
                  onClick: function onClick() {
                    setMenuActive(true);
                    toggleMenuItems("hamburgerMenu");
                  },
                  color: darkBlue
                })
              })
            })
          })]
        })
      }), (0, jsx_runtime_1.jsxs)("div", {
        style: {
          position: "relative"
        },
        children: [(0, jsx_runtime_1.jsx)(LoginForm_1.default, {
          handleClose: function handleClose(close) {
            return setOpenLogin(!close || false);
          },
          isMobile: true,
          openLogin: openLogin
        }), openMyAccountMenu && (0, jsx_runtime_1.jsx)(MyAccountMenu_1.default, {
          handleClose: function handleClose(close, isSwapAccount) {
            setOpenMyAccountMenu(!close);
            setSwapAccount(isSwapAccount || false);
          },
          isMobile: true,
          openMyAccountMenu: openMyAccountMenu,
          storeDirectory: storeDirectory
        }), (0, jsx_runtime_1.jsx)(SwapAccountMobile_1.default, {
          handleClose: function handleClose(close, isBackClicked) {
            setSwapAccount(!close);
            setOpenMyAccountMenu(isBackClicked || false);
          },
          openSwapAccount: swapAccount && !openMyAccountMenu
        }), (0, jsx_runtime_1.jsx)(BarcodeScanResults_1.default, {
          handleClose: function handleClose(close, openScanner) {
            setOpenBarcodeScanResults(!close);
            setScannerVisible(openScanner || false);
          },
          scannedBarcode: scanResult,
          storeDirectory: storeDirectory,
          openBarcodeScanResults: openBarcodeScanResults,
          purchaseOrderNumber: purchaseOrderNumber
        }), (0, jsx_runtime_1.jsx)(StructuredHamburgerMenu_1.default, {
          companyName: companyName,
          globalMenus: headerData.megaMenuHeaderMenus,
          productMenus: headerData.megaMenuProductMenus,
          locations: locationData,
          active: menuActive,
          onClose: handleMenuClose
        }), searchVisible && (0, jsx_runtime_1.jsx)(MobileSearch_1.default, {
          language: language,
          onClose: function onClose() {
            return setSearchVisible(false);
          },
          storeDirectory: storeDirectory
        }), scannerVisible && (0, jsx_runtime_1.jsxs)(WindowOverlay_1.default, {
          className: "bard-code=scanner",
          left: 0,
          top: -50,
          zIndex: frontend_common_2.IndexedLayers.underlay,
          handleClose: function handleClose() {
            return setScannerVisible(false);
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            variant: "h3",
            children: frontend_common_1.withTranslation.scanBarcode[language]
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            variant: "p",
            children: frontend_common_1.withTranslation.barcodeInstructions[language]
          }), !scanError ? (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            justifyContent: "center",
            alignItems: "center",
            direction: "column",
            children: (0, jsx_runtime_1.jsx)("div", {
              children: !scanResult ? (0, jsx_runtime_1.jsx)(BarcodeScanner_1.default, {
                handleScanError: function handleScanError(str) {
                  return onCameraError(str);
                },
                handleScanResult: function handleScanResult(str) {
                  return setScanResult(str);
                }
              }) : (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                variant: "p",
                color: success,
                children: scanResult
              })
            })
          }) : (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            justifyContent: "center",
            alignItems: "center",
            css: {
              height: 100
            },
            direction: "column",
            children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              color: red,
              variant: "div",
              children: scanError
            })
          }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
            fullwidth: true,
            size: "lg",
            type: "secondary",
            background: darkerGray,
            foreground: "light",
            label: frontend_common_1.withTranslation.cancel[language],
            onClick: function onClick() {
              return setScannerVisible(false);
            }
          })]
        })]
      })]
    })
  });
};

exports.default = FullHeaderMobile;